import { render } from "./OverlayPopupWindow.vue?vue&type=template&id=c768bb00&scoped=true"
import script from "./OverlayPopupWindow.vue?vue&type=script&lang=js"
export * from "./OverlayPopupWindow.vue?vue&type=script&lang=js"

import "./OverlayPopupWindow.vue?vue&type=style&index=0&id=c768bb00&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c768bb00"]])

export default __exports__